(() => {
  const script = document.currentScript;
  const labels = {
    eyebrow: script?.dataset.eyebrow || '',
    previous: script?.dataset.previousLabel || '',
    next: script?.dataset.nextLabel || '',
  };

  const selectors = {
    feed: '#insta-feed',
    container: '.instafeed-new-layout-container',
    track: '.instafeed-new-layout-wrapper',
    item: '.instafeed-new-layout-item',
  };

  const updateVisiblePositions = (track) => {
    const items = Array.from(track.querySelectorAll(selectors.item));

    items.forEach((item) => {
      item.classList.remove('is-ers-visible-small', 'is-ers-visible-large');
    });

    if (!window.matchMedia('(min-width: 990px)').matches) {
      return;
    }

    const trackRect = track.getBoundingClientRect();
    const visibleItems = items
      .map((item) => ({ item, rect: item.getBoundingClientRect() }))
      .filter(({ rect }) => rect.right > trackRect.left && rect.left < trackRect.right)
      .sort((first, second) => first.rect.left - second.rect.left);

    visibleItems.forEach(({ item }, index) => {
      item.classList.add(index === 1 || index === 3 ? 'is-ers-visible-small' : 'is-ers-visible-large');
    });
  };

  const getScrollAmount = (track) => {
    const firstItem = track.querySelector(selectors.item);

    if (!firstItem) {
      return track.clientWidth;
    }

    const trackStyle = window.getComputedStyle(track);
    const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || 0);

    return firstItem.getBoundingClientRect().width + gap;
  };

  const createArrow = (direction) => {
    const isPrevious = direction === 'previous';
    const button = document.createElement('button');
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');

    button.className = `ers-instafeed-app__arrow ers-instafeed-app__arrow--${direction}`;
    button.type = 'button';
    button.setAttribute('aria-label', isPrevious ? labels.previous : labels.next);
    button.dataset.ersInstafeedDirection = direction;

    svg.setAttribute('width', '33');
    svg.setAttribute('height', '12');
    svg.setAttribute('viewBox', '0 0 33 12');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');

    path.setAttribute(
      'd',
      isPrevious ? 'M32 6L8.46154 6M11.2308 9L8 6L11.2308 3' : 'M0.5 6H24.0385M21.2692 3L24.5 6L21.2692 9'
    );
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-linecap', 'square');

    svg.appendChild(path);
    button.appendChild(svg);

    return button;
  };

  const schedulePositionUpdate = (track) => {
    window.cancelAnimationFrame(track.ersInstafeedAnimationFrame);
    track.ersInstafeedAnimationFrame = window.requestAnimationFrame(() => updateVisiblePositions(track));
  };

  const initFeed = (feed) => {
    const section = feed.closest('.shopify-section');
    const heading = feed.querySelector(':scope > h2');
    const container = feed.querySelector(selectors.container);
    const track = feed.querySelector(selectors.track);

    feed.classList.add('ers-instafeed-app');
    section?.classList.add('ers-instafeed-app-section');

    if (heading && labels.eyebrow && !feed.querySelector(':scope > .ers-instafeed-app__eyebrow')) {
      const eyebrow = document.createElement('p');
      eyebrow.className = 'ers-instafeed-app__eyebrow ers-eyebrow';
      eyebrow.textContent = labels.eyebrow;
      feed.insertBefore(eyebrow, heading);
    }

    if (!container || !track) {
      return;
    }

    if (!container.querySelector('[data-ers-instafeed-direction="previous"]')) {
      container.appendChild(createArrow('previous'));
      container.appendChild(createArrow('next'));
    }

    if (track.dataset.ersInstafeedInitialized !== 'true') {
      track.addEventListener('scroll', () => schedulePositionUpdate(track), { passive: true });
      track.dataset.ersInstafeedInitialized = 'true';
    }

    container.querySelectorAll('[data-ers-instafeed-direction]').forEach((button) => {
      if (button.dataset.ersInstafeedInitialized === 'true') {
        return;
      }

      button.addEventListener('click', () => {
        const direction = button.dataset.ersInstafeedDirection === 'previous' ? -1 : 1;
        track.scrollBy({
          left: direction * getScrollAmount(track),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      });
      button.dataset.ersInstafeedInitialized = 'true';
    });

    schedulePositionUpdate(track);
  };

  const initAllFeeds = (root = document) => {
    if (root.matches?.(selectors.feed)) {
      initFeed(root);
    }

    root.querySelectorAll?.(selectors.feed).forEach(initFeed);
  };

  let mutationFrame;
  const observer = new MutationObserver((mutations) => {
    const touchesFeed = mutations.some((mutation) => {
      if (mutation.target.closest?.(selectors.feed)) {
        return true;
      }

      return Array.from(mutation.addedNodes).some(
        (node) => node.matches?.(selectors.feed) || node.querySelector?.(selectors.feed)
      );
    });

    if (!touchesFeed) {
      return;
    }

    window.cancelAnimationFrame(mutationFrame);
    mutationFrame = window.requestAnimationFrame(() => initAllFeeds());
  });

  initAllFeeds();
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('resize', () => initAllFeeds());
  document.addEventListener('shopify:section:load', (event) => initAllFeeds(event.target));
})();
